module.exports = __webpack_public_path__ + "videos/harmony_mob.bd76be7.mp4";